import * as React from 'react';
import { PublicState } from 'rheostat';

import WorkflowStep from '../WorkflowStep';
import QuoteSlider from '../QuoteSlider';
import PlanOptions from '../PlanOptions';
import Button from '../../components/buttons/Button';

interface Props {
	actions: any;
	history: any;
	match: any;
	customerPolicy: CustomerPolicy;
	planOptions: CustomerPolicyDto[];
	customerDetails: CustomerDemographicDetails;
	user: UserDetails;
	onCustomerPolicySelect: (plan: CustomerPolicy) => void;
}
interface State {
	isLoading: boolean;
}
class BespokeSelectYourPlanPage extends React.Component<Props, State> {
	state = {
		isLoading: true
	};

	private COVERAGE_MAX = 1000000;
	private COVERAGE_MIN = 25000;
	// private COVERAGE_DEFAULT = Math.round((this.COVERAGE_MAX - this.COVERAGE_MIN) / 2 + this.COVERAGE_MIN);
	private COVERAGE_DEFAULT = 500000;

	componentDidMount() {
		const { gender, birthDate, id } = this.props.user;
		const { isSmoker, age } = this.props.customerDetails;
		if (age == null || age < 18 || age > 65 || gender == null || isSmoker == null) {
			this.back();
		}
		else {
			const customerPolicy = { ...this.props.customerPolicy };
			if (this.props.customerPolicy.coverageAmount == null) {
				customerPolicy.coverageAmount = this.COVERAGE_DEFAULT;
				this.props.actions.setCustomerPolicy(customerPolicy);
			}

			const params: GetBespokePoliciesRequest = {
				coverageAmount: customerPolicy.coverageAmount,
				gender: gender,
				smoking: isSmoker,
				birthdate: birthDate,
				userId: id
			};
			this.props.actions.fetchBespokePlanOptions(params)
				.then(() => this.setState({ isLoading: false }));
		}
	}

	onSliderDragEnd = () => {
		const { gender, birthDate, id } = this.props.user;
		const { isSmoker } = this.props.customerDetails;
		const { coverageAmount } = this.props.customerPolicy;
		const params: GetBespokePoliciesRequest = {
			coverageAmount: coverageAmount,
			gender: gender,
			smoking: isSmoker,
			birthdate: birthDate,
			userId: id
		};
		this.props.actions.fetchBespokePlanOptions(params);
	}

	onCoverageUpdate = (slider: PublicState) => {
		// Rheostat uses a values list to support multiple handles. Since we only have one handle, take the first index.
		const valuePct = slider.values[0] / 100;
		const customerPolicy = {
			...this.props.customerPolicy,
			coverageAmount: Math.round(this.COVERAGE_MAX * valuePct)
		};

		this.props.actions.setCustomerPolicy(customerPolicy);
	}

	back = () => {
		this.props.history.push(`/quote/${this.props.match.params.workflow}/about-you`);
	}

	render() {
		return (
			<WorkflowStep
				title={this.props.planOptions.length > 0
					? 'Use the slider to pick a coverage amount that works for you and your family.'
					: 'Sorry, we currently do not have any plans available for you.'}
			>
				{this.props.planOptions.length > 0 &&
				<div>
				<QuoteSlider
					className="mb-4"
					min={this.COVERAGE_MIN}
					max={this.COVERAGE_MAX}
					value={this.props.customerPolicy.coverageAmount!}
					valuePrefix="$"
					titleSuffix="in coverage"
					onSliderDragEnd={this.onSliderDragEnd}
					onValuesUpdated={this.onCoverageUpdate}
				/>
				<PlanOptions
					{...this.props}
					workflow={this.props.match.params.workflow}
					isLoading={this.state.isLoading}
					className="text-center quote-plans-bespoke"
				/>
				<div className="mt-5 text-center">
					<div>
						<p className="mx-auto max-read-width">Need help deciding?</p>
						<Button to="/quote/B/your-needs" className="btn-outline-primary mb-4">Use our calculator</Button>
					</div>
					<div>
						<p className="mx-auto max-read-width">Need a different term?</p>
						<Button to="/quote/Custom/select-your-policy" className="btn-outline-primary">Build a custom policy</Button>
					</div>
				</div>
				</div>}
			</WorkflowStep>
		);
	}
}

export default BespokeSelectYourPlanPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/bespoke/BespokeSelectYourPlanPage.tsx